const mapStateToProps = state => 
     ({
        data: state.constanciaDirectivoMandatarioOrganizacionPolitica.data,
    });

export default mapStateToProps;
